import { createSelector } from "reselect";
import { IAppStore } from "../../../types/IAppStore";
import { sortWeekdays } from "../../../helpers/scheduleHelpers";

export const makeGetScheduleRows = (type: 'booking' | 'restaurant' | 'prepay') => createSelector(
  (state: IAppStore) => {
    switch (type) {
      case 'booking':
        return state.schedule.bookingRows
      case 'restaurant':
        return state.schedule.restaurantRows
      case 'prepay':
        return state.schedule.prepayRows
      }
  },
  (rows) => rows.map(r => ({ ...r, days: sortWeekdays(r.days) }))
);

export const makeGetFreeDays = (type: 'booking' | 'restaurant' | 'prepay') => createSelector(
  (state: IAppStore) => {
    switch (type) {
      case 'booking':
        return state.schedule.bookingFreeDays
      case 'restaurant':
        return state.schedule.restaurantFreeDays
      case 'prepay':
        return state.schedule.prepayFreeDays
      }
  },
  (freeDays) => Object.keys(freeDays).map(day => ({ day, free: freeDays[day] }))
);